import {Component} from 'preact'

import style from './style.scss'

class Question extends Component {
    render() {
        return (
            <div className={style.QuestionWrapper} onClick={this.props.onClick}>
                <div
                    className={style.Question}>
                    {this.props.questionTitle}
                </div>
            </div>
        )
    }
}
export default Question



// WEBPACK FOOTER //
// ./routes/HelpDesk/CategoryQuestions/Question/Question.js